import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { getApi } from "../utils/api.ts";
import { API_GET_ALL_PENDING_ACTION_REQUESTS } from "../../config/Endpoints.js";

export const usePendingActionRequests = () => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const token = Cookies.get("accessToken");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await getApi(API_GET_ALL_PENDING_ACTION_REQUESTS, token);
        setData(res?.data || []);
      } catch (err) {
        console.error("Error fetching pending requests", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [token]);

  return { data, loading };
};